import React from 'react';
import {
    TableRow,
    TableCell,
    Box,
    Avatar,
    Typography,
    LinearProgress,
    Chip,
    Button
} from '@mui/material';
import {
    Visibility as VisibilityIcon,
    CheckCircle as CheckCircleIcon
} from '@mui/icons-material';

interface MentorMatchRowProps {
    mentorMatch: any; // Using any to avoid re-declaring interfaces; consider extracting shared types later
    profile: any;
    onViewDetails: (profile: any, mentorMatch: any) => void;
    onFinalizeMatch: (menteeId: string, mentorId: string) => void;
}

const getScoreColor = (score: number) => {
    if (score >= 80) return 'success';
    if (score >= 60) return 'warning';
    return 'error';
};

const MentorMatchRow: React.FC<MentorMatchRowProps> = ({ mentorMatch, profile, onViewDetails, onFinalizeMatch }) => (
    <TableRow>
        <TableCell>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '0.75rem' }}>
                    {mentorMatch.mentor.avatar}
                </Avatar>
                <Box>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {mentorMatch.mentor.name}
                    </Typography>
                </Box>
            </Box>
        </TableCell>
        <TableCell>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LinearProgress
                    variant="determinate"
                    value={mentorMatch.overallScore}
                    color={getScoreColor(mentorMatch.overallScore) as any}
                    sx={{ width: 60, height: 6, borderRadius: 3 }}
                />
                <Typography variant="body2" sx={{ fontWeight: 500, minWidth: 45 }}>
                    {mentorMatch.overallScore}
                </Typography>
            </Box>
        </TableCell>
        <TableCell>
            <Chip
                label={mentorMatch.isMatchable ? 'Yes' : 'No'}
                color={mentorMatch.isMatchable ? 'success' : 'error'}
                size="small"
            />
        </TableCell>
        <TableCell>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                    size="small"
                    startIcon={<VisibilityIcon />}
                    onClick={() => onViewDetails(profile, mentorMatch)}
                    variant="outlined"
                >
                    Details
                </Button>
                {profile.status === 'unmatched' && mentorMatch.isMatchable && (
                    <Button
                        size="small"
                        startIcon={<CheckCircleIcon />}
                        onClick={() => onFinalizeMatch(profile.id, mentorMatch.mentor.id)}
                        variant="contained"
                        color="primary"
                    >
                        Finalize
                    </Button>
                )}
            </Box>
        </TableCell>
    </TableRow>
);

export default MentorMatchRow;
